export class ChangeStatusFormModel {
  actionId!: number
  ticketId!: number
  status!: string
  comment?: null
  commerialNumber?: number
  CloseReasonId?: number
  OtherComplaintCloseReason?: string
}
